import module_ec8febd02c0e4c869362021cfd88d069 from '../includes/glsl-compat.frag'
var fn = function( obj ){
var __t,__p='';
__p+=''+
(obj.version)+
'\nprecision '+
(obj.highp)+
' float;\n\n'+
(module_ec8febd02c0e4c869362021cfd88d069())+
'\n\nIN vec2 vTexCoordFull;\n\nuniform vec2 uFlash;\nuniform vec4 uTransform;\n\nvoid main(void){\n  float c = 0.0;\n  \n  vec2 scoord = vTexCoordFull + vec2(uTransform.xy);\n  vec2 pPos = ((scoord - vec2(0.5)) * uTransform.zw);\n  float l = smoothstep(0.0, 0.5, uFlash.x - length(pPos) * 2.0);\n  FragColor = vec4(l * uFlash.y);\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
